module.exports = __webpack_public_path__ + "img/illustration-simple-and-complex.e8a5dd5f.png";